/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_organization_activate_card_card_title = /** @type {(inputs: {}) => string} */ () => {
	return `¡Tu tarjeta Bloque te da más!`
};

const en_organization_activate_card_card_title = /** @type {(inputs: {}) => string} */ () => {
	return `Your Bloque card gives you more!`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const organization_activate_card_card_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.organization_activate_card_card_title(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("organization_activate_card_card_title", locale)
	if (locale === "es") return es_organization_activate_card_card_title(inputs)
	return en_organization_activate_card_card_title(inputs)
};
export { organization_activate_card_card_title as "organization.activate_card.card_title" }